import { render, staticRenderFns } from "./editPromoBanner.vue?vue&type=template&id=70e5e1fc&lang=pug"
import script from "./editPromoBanner.vue?vue&type=script&lang=js"
export * from "./editPromoBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports